/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from 'react';

export const useFilterAllowedProducts = (selectedServices, selectedProducts) => {
  return useMemo( () => {
    const selectedServiceIds = selectedServices?.map(s => s.id) || [];
    return (products, serviceId) => {
      return products
        .filter(product => product.services?.some(s => +serviceId === +s.service_id) || product.services.length === 0)
        .map(product => {
          const isProductSelected = selectedProducts.find(p => p.id === product.id);
          const matchedService = product.services?.find(s => selectedServiceIds.includes(+s.service_id));
          const qty = isProductSelected ? isProductSelected.qty : (+matchedService?.qty || 0);

          return {
            ...product,
            is_available: true,
            qty
          };
        })
    };
  }, [selectedServices, selectedProducts]);
}